import { ThemeMode } from '#/enum';
import { useMultiTabsContext } from '@/layouts/dashboard/multi-tabs/providers/multi-tabs-provider';
import { useSettings } from '@/store/settingStore';
import { BarChartOutlined, CalendarOutlined, CheckOutlined, FileOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import axios from 'axios';
import React, { useState } from 'react';
import { LuStepForward } from 'react-icons/lu';
import { RiPriceTag2Fill } from 'react-icons/ri';
import { TbMoneybag } from 'react-icons/tb';
import { useNavigate, useSearchParams } from 'react-router';
import { useUserActions } from '@/store/userStore';
const PaymentStatusScreen = () => {
  const navigate = useNavigate();
  const {
    themeMode
  } = useSettings();
  const {} = useMultiTabsContext();
  const {
    refreshCredits,
    setCreditsRemaining,
    setTierId,
    setTier,
    setTotalCreditsAllocated
  } = useUserActions();
  const {
    VITE_APP_URL: URL
  } = import.meta.env;
  const {
    VITE_AGENT_URL: AGENT_URL
  } = import.meta.env;
  const userId = localStorage.getItem("userId");
  const [searchParams] = useSearchParams();
  let pendingPaymentData = null;
  try {
    const pendingStr = localStorage.getItem("pending_payment");
    if (pendingStr) pendingPaymentData = JSON.parse(pendingStr);
  } catch (e) {
    console.error("Failed to parse pending payment data", e);
  }
  const plan = searchParams.get("plan") || pendingPaymentData?.plan;
  const price = searchParams.get("price") || searchParams.get("amount") || pendingPaymentData?.price;
  const credits = searchParams.get("credits") || pendingPaymentData?.credits;
  const billingCycle = searchParams.get("billingCycle") || searchParams.get("billing_cycle") || pendingPaymentData?.billingCycle;
  const tier_id = searchParams.get("tier_id") || pendingPaymentData?.tier_id;
  const [dashboardsCount, setDashboardsCount] = useState(0);
  const [isInitializing, setIsInitializing] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);
  React.useEffect(() => {
    // Clear the pending payment so it doesn't falsely trigger a failed redirect later
    localStorage.removeItem("pending_payment");
    const initializeAccount = async () => {
      if (hasInitialized || isInitializing || !userId) return;
      setIsInitializing(true);
      try {
        // 1. Migrate user
        const response = await axios.put(`${URL}/api/users/migrate-user-to-agent/${Number(userId)}`, {
          headers: {
            "Content-Type": "application/json"
          }
        });
        const updatedCount = response?.data?.updated_dashboards;
        setDashboardsCount(updatedCount || 0);
        // setDashboardsCount( 0);

        // 2. Initialize credits on Agent Backend
        if (tier_id) {
          const formData = new FormData();
          formData.append("tier_id", Number(tier_id));
          if (credits) {
            formData.append("total_credits_allocated", Number(credits));
          }
          if (plan) formData.append("tier_name", plan.toLowerCase());
          if (billingCycle) {
            const interval = billingCycle.toLowerCase().includes('annual') ? 'annually' : 'monthly';
            formData.append("reset_interval", interval);
          } else {
            formData.append("reset_interval", "monthly");
          }
          const initRes = await axios.post(`${AGENT_URL}/api/v1/user/initialize-credits`, formData, {
            headers: {
              "x-user-id": String(userId)
            }
          });
          if (initRes.data?.data) {
            setCreditsRemaining(initRes.data.data.credits_remaining);
            setTierId(initRes.data.data.tier_id);
            setTotalCreditsAllocated(initRes.data.data.total_credits_allocated);
          } else if (initRes.data?.total_credits_allocated !== undefined) {
            setCreditsRemaining(initRes.data.credits_remaining);
            setTierId(initRes.data.tier_id);
            setTotalCreditsAllocated(initRes.data.total_credits_allocated);
          }
          if (plan) {
            setTier(plan.toLowerCase());
          }

          // Refresh credits
          await refreshCredits();
        }
        setHasInitialized(true);
      } catch (error) {
        console.error("Error during auto initialization:", error);
      } finally {
        setIsInitializing(false);
      }
    };
    initializeAccount();
  }, []); // Run once on mount

  const handleNextStep = () => {
    navigate(`/dashboard/transfer-dashboards-success?plan=${plan}&count=${dashboardsCount}&credits=${credits}&billingCycle=${billingCycle}`);
  };
  return <div className='w-full flex flex-col items-center justify-center gap-3 h-full bg-[#F8FAFC] dark:bg-[#020617]'>

      {/* Tick */}
      <div className='w-[80px] h-[80px] rounded-full bg-success-lighter flex items-center justify-center'>
        <CheckOutlined style={{
        fontSize: "30px"
      }} className="text-success-dark" />
      </div>

      <h1 className='font-bold text-3xl mt-2 dark:text-white'>Payment Successful!</h1>

      <h2 className='font-bold text-success-dark text-[16px]'>Welcome to {plan?.charAt(0).toUpperCase() + plan?.slice(1)} Plan</h2>

      <span className='text-gray-600 dark:text-gray-400 text-center w-[60%] font-semibold mt-2'>Your payment of {price} was successful. You now have access to {credits} credits and all {plan} features.</span>


      {/* Box Section */}
      <div className='w-[85%] p-4 bg-[#FFFAFC] dark:bg-[#0f172a] border border-[#C4123020] dark:border-[#C4123040] mt-4 rounded-md flex'>

        <div className='border-r-[1px] border-[#C4123020] dark:border-[#C4123040] flex-1 p-4 flex gap-4'>
            <div className='w-[40px] h-[40px] rounded-md flex flex-shrink-0 items-center justify-center' style={{
          backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"
        }}>
                <BarChartOutlined style={{
            fontSize: "24px",
            color: "#C41230"
          }} />
            </div>
            <div className='flex flex-col gap-y-3'>
              <span className='text-gray-700 dark:text-gray-400 font-semibold'>Plan</span>
              <span className='font-bold capitalize dark:text-white'>{plan}</span>
            </div>
        </div>

         <div className='border-r-[1px] border-[#C4123020] dark:border-[#C4123040] flex-1 p-4 flex gap-4'>
            <div className='w-[40px] h-[40px] rounded-md flex flex-shrink-0 items-center justify-center' style={{
          backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"
        }}>
                <TbMoneybag style={{
            fontSize: "24px",
            color: "#C41230"
          }} />
            </div>
            <div className='flex flex-col gap-y-3'>
              <span className='text-gray-700 dark:text-gray-400 font-semibold'>
                {(() => {
              if (billingCycle?.toLowerCase().includes('annual')) {
                return 'Annual Credits';
              }
              if (billingCycle?.toLowerCase().includes('month')) {
                return 'Monthly Credits';
              }
              return 'Credits';
            })()}
              </span>
              <span className='font-bold text-xl dark:text-white'>{credits}</span>
            </div>
        </div>

        {billingCycle?.toLowerCase().includes('annual') && <div className='border-r-[1px] border-[#C4123020] dark:border-[#C4123040] flex-1 p-4 flex gap-4'>
              <div className='w-[40px] h-[40px] rounded-md flex flex-shrink-0 items-center justify-center' style={{
          backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"
        }}>
                  <TbMoneybag style={{
            fontSize: "24px",
            color: "#C41230"
          }} />
              </div>
              <div className='flex flex-col gap-y-3'>
                <span className='text-gray-700 dark:text-gray-400 font-semibold whitespace-nowrap'>Monthly Allotted</span>
                <span className='font-bold text-xl dark:text-white'>{credits ? Math.round(Number(credits) / 12) : 0}</span>
              </div>
          </div>}

       <div className='border-r-[1px] border-[#C4123020] dark:border-[#C4123040] flex-1 p-4 flex gap-4'>
            <div className='w-[40px] h-[40px] rounded-md flex flex-shrink-0 items-center justify-center' style={{
          backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"
        }}>
                <RiPriceTag2Fill style={{
            fontSize: "24px",
            color: "#C41230"
          }} />
            </div>
            <div className='flex flex-col gap-y-3'>
              <span className='text-gray-700 dark:text-gray-400 font-semibold'>Amount Paid</span>
              <span className='font-bold text-xl dark:text-white'>{price}</span>
            </div>
        </div>

         <div className='flex-1 p-4 flex gap-4'>
            <div className='w-[40px] h-[40px] rounded-md flex flex-shrink-0 items-center justify-center' style={{
          backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"
        }}>
                <CalendarOutlined style={{
            fontSize: "24px",
            color: "#C41230"
          }} />
            </div>
            <div className='flex flex-col gap-y-3'>
              <span className='text-gray-700 dark:text-gray-400 font-semibold'>Billing Cycle</span>
              <span className='font-bold text-xl capitalize dark:text-white'>{billingCycle}</span>
            </div>
        </div>

      </div>

      <span className='mt-2 text-gray-600 dark:text-gray-400 font-semibold text-sm'>A receipt has been sent to the email you gave for billing details</span>

      <div className='flex gap-3 items-center mt-4'>
        <Button icon={<LuStepForward />} size='large' type='primary' className='px-4' style={{
        width: "200px",
        fontWeight: "600"
      }} onClick={handleNextStep}>Next Step</Button>
        {/* <Button icon={<FileOutlined />} size='large' className='dark:bg-transparent dark:hover:!bg-[#C41230]/20' style={{
        width: "200px",
        fontWeight: "600",
        borderColor: "#C41230",
        color: "#C41230"
      }} onClick={() => navigate("/dashboard/upgrade-plan")}>View Billing</Button> */}
      </div>

    </div>;
};
export default PaymentStatusScreen;